export enum ProposalArtifactType {
    MarketQuotes = 'MarketQuotes',
    QuoteComparison = 'QuoteComparison',
    MarketingSummary = 'MarketingSummary',
}

export enum DocumentFormat {
    PDF = 'PDF',
    DOCX = 'DOCX',
}

export enum RecipientVariable {
    Insured = 'Insured',
    Client = 'Client',
    Assignee = 'Assignee',
}

// A recipient can be either or a recipient variable (enum) or a user ID (string)
export type EmailRecipient = string | RecipientVariable;

export interface EmailRecipientsConfig {
    to?: EmailRecipient[];
    cc?: EmailRecipient[];
    bcc?: EmailRecipient[];
}

export interface MarketQuotesConfig {
    type: ProposalArtifactType.MarketQuotes;
    redactCommission: boolean;
}

export interface QuoteComparisonConfig {
    type: ProposalArtifactType.QuoteComparison;
    format: DocumentFormat;
    clientBranded: boolean;
}

export interface MarketingSummaryConfig {
    type: ProposalArtifactType.MarketingSummary;
    format: DocumentFormat;
    clientBranded: boolean;
}

export type ProposalArtifactConfig = MarketQuotesConfig | QuoteComparisonConfig | MarketingSummaryConfig;

export enum FollowupEmailType {
    Followup = 'Followup',
    Escalation = 'Escalation',
}

export interface FollowupEmailItemConfig {
    daysInterval: number;
    type: FollowupEmailType;
    templateName: string;
}

export interface FollowupEmailItem extends FollowupEmailItemConfig {
    type: FollowupEmailType.Followup;
    recipients?: EmailRecipientsConfig; // recipients are optional for followup emails
}

export interface EscalationEmailItem extends FollowupEmailItemConfig {
    type: FollowupEmailType.Escalation;
    recipients: EmailRecipientsConfig; // recipients are required for escalation emails
}

export type FollowupEmailConfig = FollowupEmailItem | EscalationEmailItem;

export interface PlacementTaskStepConfig {
    // Remarketing config:
    productIds?: string[];
    premiumIncreaseThresholdPercent?: number;

    // Send proposal config:
    proposalArtifacts?: ProposalArtifactConfig[];
    proposalEmailRecipients?: EmailRecipientsConfig;
    proposalEmailTemplateId?: string;

    // Send solicitation config:
    solicitationEmailRecipients?: EmailRecipientsConfig;
    solicitationEmailTemplateId?: string;
    solicitationAttachmentIds?: string[];

    // Followup email config:
    followupEmails?: FollowupEmailConfig[];
}
